<template>
  <div :class="dynaClass">
    <div class="autoselect-options-container">
      <div v-if="showDropdown" class="autoselect-options">
        <div v-for="option in rangos" :key="option.value">
          <span @mousedown="onOptionClick(option.value)" :title="option.label">{{
            option.label
          }}</span>
        </div>
      </div>
      <img
        class="caret"
        v-if="showCaret"
        :src="caret"
        @click="toggleDropdown"
        alt="seleccion-rango"
      />
    </div>
    <text-input
      ref="textInput"
      class="text-input"
      :disabled="disabled"
      :hint="hint"
      :label="label"
      :value="selectedValue"
      :required="true"
      :subhint="subhint"
      :validationError="validationError"
      pattern="[0-9]*"
      :inputmode="inputMode"
      @input="onInput"
      @focus="onFocus"
      @blur="onBlur"
      @click="toggleDropdown"
    />
  </div>
</template>

<script>
import { tipoDeCobro as _tipoDeCobro } from "@/config/constants";
import TextInput from "@/components/core/TextInput";

export default {
  name: "TypePay",
  components: { TextInput },
  props: [
    "placeholder",
    "label",
    "value",
    "hint",
    "subhint",
    "validationError",
    "items",
    "inputMode",
    "tipoActividad"
  ],
  data() {
    return {
      focused: false,
      forceShowDropdown: false,
      disabled: false, // Ahora el select está habilitado
      caret: require("@/assets/img/1x/arrow-simple-down.svg"),
      rangos: [],
      esPF: this.$store.getters.getPaso1().esPF
    };
  },
  created() {
    this.getRangos();
  },
  methods: {
    getRangos() {
      this.rangos = _tipoDeCobro.map(item => ({
        value: item.value,
        label: item.label,
      }));
    },
    onInput(val) {
      this.$emit("input", val);
    },
    onFocus() {
      if (!this.disabled) {
        this.focused = true;
        this.forceShowDropdown = true;
      }
    },
    onBlur() {
      setTimeout(() => {
        this.focused = false;
        this.forceShowDropdown = false;
      }, 250);
    },
    onOptionClick(val) {
      this.$emit("input", val);
      this.forceShowDropdown = false;
    },
    toggleDropdown() {
      if (!this.disabled) {
        this.forceShowDropdown = !this.forceShowDropdown;
        this.focused = this.forceShowDropdown;
      }
    },
  },
  computed: {
    showCaret() {
      return !this.value;
    },
    showDropdown() {
      return this.forceShowDropdown;
    },
    selectedValue() {
      let option = this.rangos.find(val => val.value === this.value);
      return option ? option.label : "";
    },
    dynaClass() {
      return this.disabled ? "container disabled" : "container";
    }
  },
};
</script>

<style scoped>
.autoselect-options-container {
  position: relative;
}

.autoselect-options-container .caret {
  position: absolute;
  right: 0;
  top: 0;
  /* El borde es para agrandar el area clickeable */
  border-right: 16px solid transparent;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
  cursor: pointer;
  z-index: 1;
}

.autoselect-options {
  position: absolute;
  z-index: 10;
  left: 0;
  right: 0;
  top: 56px; /* Alto inputs */
  background: white;
  max-height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
  box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.2);
}

.autoselect-options span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 16px 0;
  border-bottom: 1px solid #bdbdbd;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  cursor: pointer;
}

.autoselect-options div {
  padding: 0 16px;
}
.autoselect-options div:hover {
  background-color: #eeeeee;
}

.autoselect-options div:last-child span {
  border-bottom: 0;
}

.autoselect-options span:hover {
  color: #000;
}

</style>
